import { useTranslation } from "react-i18next";

const ContactButton = ({ type = "mail", href }) => {
  const { t } = useTranslation();

  const config = {
    mail: {
      icon: require("../../../assets/images/mail-icon.png"),
      label: t("identity.contact-email"),
      paddingY: "py-8",
    },
    whatsapp: {
      icon: require("../../../assets/images/whatsapp-icon.png"),
      label: t("identity.contact-whatsapp"),
      paddingY: "py-6",
    },
  };

  const { icon, label, paddingY, onlyMobile } = config[type];

  return (
    <a
      className={`${
        onlyMobile ? "md:hidden" : ""
      }  flex flex-col sm:leading-4 md:leading-8 items-center space-x-2 px-1 ${paddingY} mx-1 border rounded font-medium text-center font-league-medium w-3/6 max-w-full bg-white`}
      href={href}
    >
      <img src={icon} className="w-8 h-8 mx-auto" alt={`${type} icon`} />
      <span className="w-full text-center pt-2">{label}</span>
    </a>
  );
};

export default ContactButton;
